import { Button, Stack } from '@mui/material';

import { Alert, Text } from 'common';

import { useAgenticChatContext } from '../../components/AgenticChat/context';

export function AgenticChatNewSession() {
  const { createSessionMutation, startNewChat } = useAgenticChatContext();

  return (
    <Stack gap={2} sx={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      <Text variant="heading2">What can we do today?</Text>
      {createSessionMutation.isError && <Alert error={createSessionMutation.error} />}
      <Button
        variant="contained"
        loading={createSessionMutation.isPending}
        onClick={() => startNewChat()}
      >
        {createSessionMutation.isError ? 'Retry starting chat' : 'New Chat'}
      </Button>
    </Stack>
  );
}
